export const NEW_QUOTE_WORKSPACE_ID = 'new';

export const quoteWorkspacePath = (
  eventId: number | string,
  search = ''
) => {
  const params = new URLSearchParams(search);
  params.set('tab', 'quote');

  return `/dashboards/jobTracker/positions/${eventId}?${params.toString()}`;
};

export const newQuoteWorkspacePath = (search = '') =>
  quoteWorkspacePath(NEW_QUOTE_WORKSPACE_ID, search);

export const isNewQuoteWorkspaceId = (eventId?: string) =>
  eventId === NEW_QUOTE_WORKSPACE_ID;
